import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

// components
import Pie from "app/static/frontend/widgets/components/visualization/Pie"

// action creators
import { showInSearch } from "app/static/frontend/projects-new/list/action-creators"

// selectors
import { selectPieVisualizationData } from "app/static/frontend/widgets/selectors/pieVisualizationWidgetSelectors"
import { selectWidgetDataSources } from "app/static/frontend/widgets/selectors/selectors"

const mapStateToProps = createStructuredSelector({
    data: selectPieVisualizationData,
    dataSources: selectWidgetDataSources,
})

const mapDispatchToProps = {
    showInSearch,
}

export default connect(mapStateToProps, mapDispatchToProps)(Pie)
